import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import MDTypography from 'components/MDTypography';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';

const CheckboxField = ({
    field,
    data,
    change,
    matchedSub,
    renderRows,
    keyPrefix,
}) => (
    <Box>
        <FormControlLabel
            control={
                <Checkbox
                    size="small"
                    checked={data[field.key] || false}
                    onChange={(e) => change(field.key, e.target.checked)}
                />
            }
            label={
                <MDTypography variant="body2" fontWeight="medium" component="span">
                    <FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />
                </MDTypography>
            }
        />

        {matchedSub && (
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                {renderRows(matchedSub.rows, matchedSub.fields, data, change, keyPrefix)}
            </Box>
        )}
    </Box>
);

export default CheckboxField;
